import script from "./UserDetailsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailsTableLoader.vue?vue&type=style&index=0&id=7d3b185e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3b185e"]])

export default __exports__